import { Controller } from "@hotwired/stimulus"
import { prefersReducedMotion } from "../lib/motion"

// Plays a block's entrance motion the first time it is actually on screen (a collapsed dashboard is not, until it
// opens): adds .is-in (CSS draws rings/sparklines, grows bars) and counts [data-count-to] numbers up from 0.
// The server-rendered text is already the final value, so without JS or with reduced motion nothing changes.
export default class extends Controller {
  connect() {
    if (prefersReducedMotion() || !("IntersectionObserver" in window)) {
      this.element.classList.add("is-in")
      return
    }
    this.observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting && entry.intersectionRect.height > 0)) return
      this.observer.disconnect()
      this.element.classList.add("is-in")
      this.countUp()
    }, { threshold: 0.15 })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
    cancelAnimationFrame(this.frame)
  }

  countUp() {
    const counters = [ ...this.element.querySelectorAll("[data-count-to]") ].map((el) => ({
      el,
      to: parseFloat(el.dataset.countTo) || 0,
      decimals: parseInt(el.dataset.countDecimals || "0", 10),
      suffix: el.dataset.countSuffix || ""
    }))
    if (!counters.length) return

    const duration = 800
    const start = performance.now()
    const format = ({ decimals, suffix }, value) =>
      value.toLocaleString("en-US", { minimumFractionDigits: decimals, maximumFractionDigits: decimals }) + suffix
    const step = (now) => {
      const t = Math.min((now - start) / duration, 1)
      const eased = 1 - (1 - t) ** 3
      counters.forEach((counter) => { counter.el.textContent = format(counter, counter.to * eased) })
      if (t < 1) this.frame = requestAnimationFrame(step)
    }
    this.frame = requestAnimationFrame(step)
  }
}
